import { type WithingsOrderPostContentObjectDetail, createWithingsOrderPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { getOrderPost } from 'features/feed/services';
import { editWithingsOrderPost } from '../../services';

type UpdateWithingsOrderPostData = {
  htmlContent: string;
  programId: string;
  programTopicId: string;
  publishAt: Date;
  textContent: string;
  title?: string;
  todoDueDate?: Date;
  withingsPostOrderId: string;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useUpdateWithingsOrderPostMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<WithingsOrderPostContentObjectDetail, UpdateWithingsOrderPostData>({
    async mutationFn({
      htmlContent,
      programId,
      programTopicId,
      publishAt,
      textContent,
      title,
      todoDueDate,
      withingsPostOrderId,
    }) {
      const editOrderPostResponse = await editWithingsOrderPost({
        htmlContent,
        programId,
        programTopicId,
        publishAt,
        textContent,
        title,
        todoDueDate,
        withingsPostOrderId,
      });
      const orderPostResponse = await getOrderPost({ routeParams: { id: editOrderPostResponse.data.id } });

      return createWithingsOrderPostContentObjectDetail(orderPostResponse.data);
    },
    onSuccess(data) {
      cache.replace(data);
    },
  });
};
